import { Weld } from '@bechtel/types';

export interface WeldDetailTabsProps {
  weld: Weld;
  isFitupRequired: boolean;
  showItrCertDialog?: boolean;
  close: () => void;
}

export interface WeldDetailTab {
  label: string;
  value: WeldDetailTabType;
  visible: boolean;
}
export enum WeldDetailTabType {
  REASSIGN = 'REASSIGN',
  ASSIGN = 'ASSIGN',
  DETAILS = 'DETAILS',
  HISTORY = 'HISTORY',
}

export enum MilestoneName {
  FitUp = 'Fitup',
  Install = 'Install',
}
